<template>
  <q-page>
    <main-header
      img-src="/img/services/transfer-bg.jpg"
    />
    <div class="row">
      <div class="q-ma-md offset-md-3 col-md-6">
        <h4 class="text-bold text-center">
          {{ $t('pages.services.page_title') }}
        </h4>
        <q-list
          class="q-gutter-md"
          dense
        >
          <q-item
            v-for="page in pages"
            :key="page"
            :to="{ name: `services.${page}` }"
            class="service-item"
          >
            <div
              :style="{ backgroundImage: `url(img/services/${page}.jpg)` }"
              class="col-sm-4 col-xs-12 q-mr-md service-item--image"
            />
            <div class="col-sm-8 col-xs-12 service-item--caption">
              <h3 class="q-my-none text-h6 text-bold">
                {{ $t(`pages.services.${page}.title_for_services_list`) }}
              </h3>
              <div class="text-caption-color text-weight-medium q-mt-sm">
                {{ $t(`pages.services.${page}.description`) }}
              </div>
            </div>
          </q-item>
        </q-list>
      </div>
    </div>
  </q-page>
</template>

<script>
import MainHeader from 'components/MainHeader';

export default {
  name: 'ServicesIndex',
  components: {
    MainHeader,
  },
  data() {
    return {
      pages: [
        'airport_transfer',
        'vip_transfer',
        'bus_rental',
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.text-caption-color {
  color: #808080;
}
.service-item {
  padding: 0 25px 0 0;
  box-shadow: 0 0 8px rgba(#000, .1);
  border-radius: 4px;
  border: 2px solid #fff;
  &--caption {
    padding: 25px 0;
    font-size: 15px;
  }
  &--image {
    background-size: cover;
    border-radius: 4px 0 0 4px;
    min-height: 132px;
  }
  @media (max-width: 599px) {
    display: flex;
    flex-flow: column;

    padding-right: 0;
    &--caption {
      padding: 16px;
    }
    &--image {
      border-radius: 4px 4px 0 0;
    }
  }
}
</style>
